import { Module } from '@/configuration/module';
import DASHBOARD_MODULE from '@/configuration/modules/DASHBOARD_MODULE';
import SEARCH_MODULE from '@/configuration/modules/SEARCH_MODULE';
import { generateModules } from '@/configuration/module-registry-helper';
import CURRENT_USER_MODULE from "@/configuration/modules/CURRENT_USER_MODULE";
import WORKING_TIME_MODULE from './modules/WORKING_TIME_MODULE';
import PROJECT_MANAGEMENT_MODULE from './modules/PROJECT_MANAGEMENT_MODULE';
import PRODUCT_MODULE from "@/configuration/modules/PRODUCT_MODULE";
import REPORT_MODULE from './modules/REPORT_MODULE';
import OFFICIAL_HOLIDAYS_MODULE from '@/configuration/modules/OFFICIAL_HOLIDAYS_MODULE';
import EMPLOYEES_MODULE from './modules/EMPLOYEES_MODULE';
import HOLIDAY_MODULE from '@/configuration/modules/HOLIDAY_MODULE';
import WAREHOUSE_MODULE from '@/configuration/modules/WAREHOUSE_MODULE';
import CONFIGURATION_MODULE from '@/configuration/modules/CONFIGURATION_MODULE';
import NAVISION_MODULE from '../../src/configuration/modules/NAVISION_MODULE';
import PROCESS_SUPPORT_MODULE from "@/configuration/modules/PROCESS_SUPPORT_MODULE";

const modules = [
  /* ### Search ### */
  new Module.Builder(SEARCH_MODULE.SEARCH_GROUP_WRAPPER)
    .with(SEARCH_MODULE.CHILDREN.SEARCH_MODULE)
    .build(),
  /* ### Dashboard ### */
  new Module.Builder(DASHBOARD_MODULE.DASHBOARD_GROUP_WRAPPER)
    .with(DASHBOARD_MODULE.CHILDREN.DASHBOARD_MODULE)
    .build(),
  /* ### Current User ### */
  new Module.Builder(CURRENT_USER_MODULE.CURRENT_USER_GROUP_WRAPPER)
    .with(CURRENT_USER_MODULE.CHILDREN.USER_PROFILE_MODULE)
    .build(),
  /* ### Workingtime ### */
  new Module.Builder(WORKING_TIME_MODULE.WORKING_TIME_GROUP_WRAPPER)
    .with(WORKING_TIME_MODULE.CHILDREN.TIMETRACKING_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.ATTENDANCE_TYPES_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.MONTH_BALANCE_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.OVERTIME_TRIM_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.SICK_NOTES_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.MONTH_OF_EMPLOYEES_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.REOPEN_MONTH_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.MONTH_CONFIRMATION_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.MONTH_STATUS_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.MONTHLY_EMPLOYEE_PROGRESS_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.MONTHLY_ABSENCE_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.MONTHLY_ABSENCE_CONFIGURATION_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.MONTHLY_VERIFICATION_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.ABSENCE_EXPORT)
    .with(WORKING_TIME_MODULE.CHILDREN.WORKING_HOURS_IMPORT_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.WORKING_DAY_CONFIGURATION)
    .with(WORKING_TIME_MODULE.CHILDREN.OPEN_PROCESSES)
    .build(),
  /* ### Project Management ### */
  new Module.Builder(PROJECT_MANAGEMENT_MODULE.PROJECT_MANAGMENT_GROUP_WRAPPER)
    .with(PROJECT_MANAGEMENT_MODULE.CHILDREN.PROJECTS_MODULE)
    .with(PROJECT_MANAGEMENT_MODULE.CHILDREN.INQUIRIES_MODULE)
    .with(PROJECT_MANAGEMENT_MODULE.CHILDREN.TEMPLATE_MODULE)
    .with(PROJECT_MANAGEMENT_MODULE.CHILDREN.PROJECT_PROGRESS_MODULE)
    .build(),
  /* ### Product ### */
  new Module.Builder(PRODUCT_MODULE.PRODUCT_GROUP_WRAPPER)
    .with(PRODUCT_MODULE.CHILDREN.PRODUCT_MODULE)
    .build(),
  /* ### Report ### */
  new Module.Builder(REPORT_MODULE.REPORTS_GROUP_WRAPPER)
    .with(REPORT_MODULE.CHILDREN.ABSENT_OVERVIEW_MODULE)
    .with(REPORT_MODULE.CHILDREN.ABSENT_REPORT_MODULE)
    .with(REPORT_MODULE.CHILDREN.OCC_REPORT_MODULE)
    .with(REPORT_MODULE.CHILDREN.EMPLOYEE_REPORT_MODULE)
    .with(REPORT_MODULE.CHILDREN.PROJECT_HOURS_MODULE)
    .with(REPORT_MODULE.CHILDREN.PROJECT_BUDGET_REPORT_MODULE)
    .with(REPORT_MODULE.CHILDREN.BALANCE_MODULE)
    .with(REPORT_MODULE.CHILDREN.BALANCE_CHANGE_MODULE)
    .with(REPORT_MODULE.CHILDREN.WEEKEND_OFFICIAL_HOLIDAY_REPORT_MODULE)
    .with(REPORT_MODULE.CHILDREN.EMPLOYEE_OVERVIEW_REPORT)
    .build(),
  /* ### Official Holiday ### */
  new Module.Builder(OFFICIAL_HOLIDAYS_MODULE.OFFICIAL_HOLIDAYS_GROUP_WRAPPER)
    .with(OFFICIAL_HOLIDAYS_MODULE.CHILDREN.OFFICIAL_HOLIDAYS_MODULE)
    .with(OFFICIAL_HOLIDAYS_MODULE.CHILDREN.OFFICIAL_HOLIDAYS_CALENDARS_MODULE)
    .with(OFFICIAL_HOLIDAYS_MODULE.CHILDREN.STATES_MODULE)
    .build(),
  /* ### Employees ### */
  new Module.Builder(EMPLOYEES_MODULE.EMPLOYEES_GROUP_WRAPPER)
    .with(EMPLOYEES_MODULE.CHILDREN.EMPLOYEES_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.ROLES_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.GROUPS_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.DEPARTMENTS_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.DEPUTY_TYPE_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.LDAP_SYNCHRONIZATION)
    .with(EMPLOYEES_MODULE.CHILDREN.CURRICULUM_VITAE_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.CV_REPORT_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.SKILL_MATRIX_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.SKILL_CATEGORIES_MODULE)
    .build(),
  /* ### Holiday ### */
  new Module.Builder(HOLIDAY_MODULE.HOLIDAY_GROUP_WRAPPER)
    .with(HOLIDAY_MODULE.CHILDREN.HOLIDAYS_MODULE)
    .with(HOLIDAY_MODULE.CHILDREN.HOLIDAY_ENTITLEMENT_MODULE)
    .with(HOLIDAY_MODULE.CHILDREN.HOLIDAY_ENTITLEMENTS_MODULE)
    .with(HOLIDAY_MODULE.CHILDREN.DEPUTIES_MODULE)
    .with(HOLIDAY_MODULE.CHILDREN.APPROVALS_MODULE)
    .build(),
  /* ### Warehouse ### */
  new Module.Builder(WAREHOUSE_MODULE.WAREHOUSE_GROUP_WRAPPER)
    .with(WAREHOUSE_MODULE.CHILDREN.COMPANY_LOCATIONS_MODULE)
    .build(),
  /* ### PROCESS_SUPPORT ### */
  new Module.Builder(PROCESS_SUPPORT_MODULE.PROCESS_SUPPORT_GROUP_WRAPPER)
    .with(PROCESS_SUPPORT_MODULE.CHILDREN.NOTIFICATION_GROUPS_MODULE)
    .with(PROCESS_SUPPORT_MODULE.CHILDREN.MESSAGE_MODULE)
    .build(),
  /* ### Navision ### */
  new Module.Builder(NAVISION_MODULE.NAVISION_GROUP_WRAPPER)
    .with(NAVISION_MODULE.CHILDREN.IMPORT_MODULE)
    .with(NAVISION_MODULE.CHILDREN.EXPORT_MODULE)
    .build(),
  /* ### System configuration ### */
  new Module.Builder(CONFIGURATION_MODULE.SYS_CONFIG_GROUP_WRAPPER)
    .with(CONFIGURATION_MODULE.CHILDREN.REGISTRY_MODULE)
    .with(CONFIGURATION_MODULE.CHILDREN.CONFIG_FIXTURES_MODULE)
    .with(CONFIGURATION_MODULE.CHILDREN.DOCUMENT_MODULE)
    .with(CONFIGURATION_MODULE.CHILDREN.ADMIN_CONSOLE_MODULE)
    .build(),
]

export default generateModules(modules);
